﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_customIPAddressList from './tpl/customIPAddressList.html';
import View_CustomIPAddressListItem from './customIPAddressListItem';

export default Marionette.CollectionView.extend({
    //tagName: 'customIPAddressList',
   // tagName: 'ul',
  //  className: 'd-flex flex-column-reverse todo-list',
    childViewContainer: '#customIPAddressList',
    childView: View_CustomIPAddressListItem,
    getTemplate: function () {
        return tpl_customIPAddressList();
    },
    initialize: function () {
        this.app = this.options.app;
    },
    buildChildView: function(child, ChildViewClass, childViewOptions){
        var options = _.extend({model: child}, childViewOptions);
        options.app = this.app;
        var view = new ChildViewClass(options);
        return view;
    }
});